@if (showApp) {
  <router-outlet/>

  <!--  <button mat-stroked-button (click)="runtimeError()">Runtime error</button>-->
  <!--  <button mat-stroked-button (click)="http404()">HTTP 404</button>-->
  <!--  <button mat-stroked-button (click)="httpStatus0()">HTTP status 0 (simulado)</button>-->
} @else {
  @if (growUpImage) {
    <div class="splash">
      <img src="assets/image/svg/mar-logo-white.svg" alt="Logo">
    </div>
  }
}


